/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";

// TC UX
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";

import sectionCardsStyles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards";
const styles = createStyles(sectionCardsStyles as any);

import { ContentDataType } from "./landingPageContent";
interface Props extends WithStyles<typeof styles> {
  content: ContentDataType;
}

const PhoenixWhyCardBase: React.FC<Props> = ({ classes, content }: Props) => {
  const target = (padding: string) => (
    <h3 style={{ padding, margin: 0 }}>
      <b style={{ color: content.color }}>{content.title}</b>
    </h3>
  );
  const HtmlToReactParser = require("html-to-react").Parser;
  const parser = new HtmlToReactParser();
  return (
    <div className={classes.rotatingCardContainer}>
      <Card className={classes.cardRotate}>
        <div className={classes.front + " " + classes.wrapperBackground}>
          <CardHeader image>
            <img src={content.image} alt={content.title} />
            <div
              className={classes.coloredShadow}
              style={{ backgroundImage: `url(${content.image})` }}
            />
          </CardHeader>
          {target("2rem 0")}
        </div>
        <div className={classes.back + " " + classes.wrapperBackground}>
          <CardHeader image>
            <div className={classes.whoCardBack}>
              {target("0")}
              <h5 style={{ textAlign: "left" }}>
                {parser.parse(content.content)}
              </h5>
            </div>
          </CardHeader>
        </div>
      </Card>
    </div>
  );
};

export const PhoenixWhyCard = withStyles(styles)(PhoenixWhyCardBase);
